module.exports = __webpack_public_path__ + "img/List.d3a6944f.svg";